import { Theme } from "../../components/constants";

export default {
    text: {
		fontSize: "16px",
		color: Theme.TEXT_PRIMARY_BLACK,
		whiteSpace: 'pre'
	},
	customPopupStyle: { 
		width: '50vw', 
		maxWidth: '50vw' 
	},
	padding: { 
		padding: '40px' 
	},
	red: {
		color: 'red'
	},
	filterRow: {
		display: 'flex', 
		justifyContent: 'space-between', 
		alignItems: 'center', 
		gap: '50px', 
		padding: '20px'
	},
	flexOne: {
		flex: 1
	},
	fullWidth: {
		width: '100%'
	},
	popupBody: {
		display: 'flex', 
		flexDirection: 'column', 
		gap: '10px'
	},
	checkBoxConatiner: { marginLeft: "25px" },
	checkBoxLabel: { color: "#525f7f", marginLeft: "20px" },
	actionsRow: {
		display: 'flex', 
		gap: '20px', 
		marginTop: '30px'
	},
	mainContainer: {
		display: 'flex', 
		flexDirection: 'column',
		gap: '10px'
	},
	headerRow: {
		display: 'flex', 
		gap: '10px',
		height: '50px'
	},
	fontSize24: {
		fontSize: '24px',
	},
	quickActionsRow: {
		display:'flex', 
		gap: '50px', 
		padding: '40px', 
		justifyContent: 'space-evenly'
	},
	quickAction: {
		display: 'flex', 
		flexDirection: 'column', 
		alignItems: 'center', 
		justifyContent: 'space-between', 
		flex: 1, 
		maxWidth:'500px', 
		padding: '30px',
		background: '#fff',
		borderRadius: '10px'
	},
	quickActionHeaderRow: {
		display: 'flex', 
		flexDirection: 'column', 
		gap: '15px', 
		width: '100%'
	},
	fontSize16: {
		fontSize: '16px', 
		margin: '0px'
	},
	quickActionCTA: {
		display: 'flex', 
		gap: '10px', 
		alignItems: 'center',
		cursor: 'pointer',
	},
	quickActionCTALabel: {
		color: '#215DAA', 
		fontSize: '16px',
		fontWeight: 700,
	},
	quickActionBottomRow: {
		display: 'flex', 
		alignItems: 'end', 
		justifyContent: 'space-between', 
		width: '100%'
	},
	explorePlanSection: {
		display: 'flex', 
		alignItems: 'center', 
		justifyContent: 'space-between', 
		padding: '20px', 
		background: '#E5EEFA'
	},
	explorePlanLeftContainer: {
		display: 'flex', 
		alignItems: 'center', 
		gap: '15px'
	},
	explorePlanLeftText: {
		display: 'flex', 
		flexDirection: 'column', 
		gap: '10px'
	},
	explorePlanLeftSubText: {
		display: 'flex', 
		alignItems: 'center', 
		gap: '20px'
	},
	explorePlanButton: {
		color: '#215DAA', 
		fontWeight: 700, 
		padding: '8px 40px', 
		background: 'transparent'
	},
	miniCTARow: {
		display: 'flex', 
		alignItems: 'center', 
		justifyContent: 'space-evenly',
		margin: '30px 0px'
	},
	miniCTA: {
		display: 'flex', 
		alignItems: 'center', 
		gap: '20px'
	},
	fullHeight: {
		height: '100%'
	},
	gridActions: { 
		display: 'flex', 
		gap: '10px' 
	},
	insightsBadge: {
		height: '20px', 
		width: '20px', 
		borderRadius: '50%', 
		border: '0.5px solid #BEBEBE', 
		color: '#E1817E', 
		fontWeight: '700', 
		fontSize: '0.5rem', 
		backgroundColor: 'white', 
		display: 'flex', 
		alignItems: 'center', 
		justifyContent: 'center', 
		position: 'absolute', 
		top: '-8px', 
		right: '-8px',
	},
	homeSectionAlternateGreetingsRow: {
		backgroundColor: '#FDF4D5', 
		width: '100%', 
		display: 'flex', 
		alignItems: 'center', 
		padding: '0px 20px', 
		borderRadius: '5px'
	},
	miniCTAInnerRow: {
		height: '100%', 
		display: 'flex', 
		alignItems: 'flex-end'
	},
	insightsRow: {
		backgroundColor: '#E5EEFA', 
		display: 'flex', 
		minHeight: '50px', 
		padding: '0px 20px', 
		alignItems: 'center', 
		borderRadius: '5px', 
		justifyContent: 'space-between'
	},
	insightsInnerRow: {
		display: 'flex', 
		gap: '30px'
	},
	insightsIconsSection: {
		display: 'flex', 
		gap: '27px'
	},
	positionRelative: {
		position: 'relative'
	},
	urgentMainContainer: {
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        gap: '13px'
    },
	urgentIssuesHeader: { 
		fontWeight: 700, 
		fontSize: '20px'
	},
	urgentIssueInnerContainer: {
		display: 'flex', 
		width: '400px', 
		transition: 'transform 0.5s ease'
	},
	width400: {
		width: '400px'
	},
	urgentIssuesBottomBars: {
		display: 'flex', 
		gap: '10px', 
		justifyContent: 'center'
	},
	urgentIssuesBottomButton: {
		height: '10px', 
		cursor: 'pointer',
	},
	urgentIssuesDeactiveState: {
		width: '10px', 
		backgroundColor: 'gray', 
		borderRadius: '50%'
	},
	urgentIssuesActiveState: {
		width: '50px', 
		backgroundColor: '#83CFA4', 
		borderRadius: '20px'
	},
	exportToExcelButtonDiv: {
		alignSelf: 'flex-end'
	},
	exportToExcelButton: {
		display: 'flex', 
		gap: '10px', 
		alignItems: 'center', 
		padding: '10px 25px'
	},
	testAccountWarningBody:{
		flexWrap: 'wrap',
	},
	testAccountWarningBodyText: {
		color: Theme.DANGER,
		flex: "1"
	},
	redirectToUrl: {
		color: Theme.PRIMARY,
		width: "100%",
		textAlign: "center"
	},
}